import { handleAPI, API_VERSION_ONE } from '../../utils/apiUtils';

export function fetchIntercomToken() {
  const url = `/${API_VERSION_ONE}/intercom/token`;
  return handleAPI(url, {}, 'GET').then((response) => response.data?.data);
}
